import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import ArcadeScoreBar from "./ArcadeScoreBar";

function shuffle(s) {
  const a = s.split("");
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a.join("");
}

const WORDS = ["TIGER", "PIRATE", "VICTORY", "GALAXY", "PHOENIX", "OCEAN", "DRAGON", "CRYSTAL", "STORM", "EMBER", "FROST", "RIVAL"];

export default function WordScramble() {
  const [target, setTarget] = useState(WORDS[0]);
  const [scrambled, setScrambled] = useState(shuffle(WORDS[0]));
  const [guess, setGuess] = useState("");
  const [result, setResult] = useState(null);
  const [sessionScore, setSessionScore] = useState(0);
  const [streak, setStreak] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const { refreshMe, user } = useAuth();

  const next = () => {
    const w = WORDS[Math.floor(Math.random() * WORDS.length)];
    setTarget(w);
    let s = shuffle(w);
    if (s === w) s = shuffle(w);
    setScrambled(s);
    setGuess("");
    setResult(null);
  };

  const submit = async (e) => {
    e?.preventDefault();
    const won = guess.toUpperCase() === target;
    setResult(won ? "win" : "lose");
    try {
      await api.post("/games/result", { game_slug: "wordscramble", won });
      if (won) {
        refreshMe();
        // Score = word length × 100 × (1 + streak/10)
        const nextStreak = streak + 1;
        const points = Math.round(target.length * 100 * (1 + nextStreak / 10));
        const next = sessionScore + points;
        setStreak(nextStreak);
        setSessionScore(next);
        if (user) {
          api.post("/arcade/score", { game_slug: "wordscramble", score: next })
            .then(() => setRefreshKey(k => k + 1))
            .catch(() => {});
        }
      } else {
        setStreak(0);
      }
    } catch { /* ignore */ }
  };

  return (
    <div data-testid="game-wordscramble" className="bg-black/60 border border-white/10 rounded-md p-6 max-w-md mx-auto text-center">
      <div className="sc-heading text-2xl font-bold mb-2">Word Scramble</div>
      <div className="text-xs text-zinc-400 mb-6">Unscramble the letters · streak multiplies score</div>
      <div className="flex items-center justify-center gap-6 text-xs sc-mono mb-4">
        <div>SESSION <span className="text-[color:var(--sc-volt)] font-bold" data-testid="ws-session-score">{sessionScore}</span></div>
        <div>STREAK <span className="text-[color:var(--sc-cyan)] font-bold">×{1 + streak / 10}</span></div>
      </div>
      <div className="text-5xl font-mono tracking-[0.3em] font-black my-6 text-[#00E5FF]">{scrambled}</div>
      <form onSubmit={submit}>
        <input
          data-testid="wordscramble-input"
          value={guess}
          onChange={e => setGuess(e.target.value)}
          placeholder="Type the word"
          className="sc-input text-center uppercase tracking-widest mb-3"
          maxLength={target.length}
        />
        <button type="submit" className="sc-btn w-full" data-testid="wordscramble-submit">Check</button>
      </form>
      {result === "win" && <div className="text-[#10B981] font-bold mt-4">Correct! +{target.length * 100} × streak bonus</div>}
      {result === "lose" && <div className="text-[#FF3366] font-bold mt-4">Wrong — it was {target}</div>}
      <button onClick={next} className="sc-btn-ghost text-xs mt-4">Next Word</button>
      <ArcadeScoreBar gameSlug="wordscramble" refreshKey={refreshKey} />
    </div>
  );
}
